// 低版本浏览器兼容性api
if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    index = Math.trunc(index) || 0
    if (index < 0) index += this.length
    if (index < 0 || index >= this.length) return undefined
    return this[index]
  }
}

if (typeof window.queueMicrotask !== 'function') {
  window.queueMicrotask = function(callback) {
    Promise.resolve()
      .then(callback)
      .catch(e => setTimeout(() => { throw e }))
  }
}